import React from 'react'
import { Field } from 'formik'
import { FormControlLabel, Switch } from '@material-ui/core'

const InputComponent = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, values }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
  <FormControlLabel
    {...field}
    {...props}
    error={touched[field.name] && Boolean(errors[field.name])}
    helperText={errors[field.name] || props.helperText}
    checked={values[field.name]}
    control={<Switch />}
  />
)

const FormField = (props) => <Field component={InputComponent} {...props} />

export default FormField
